import React, { useRef, useEffect, useState } from 'react';

/**
 * VU-style animated bars that pulse while the mic is active.
 * Pure CSS animation — no getUserMedia or AudioContext overhead.
 * The Web Speech API already has the mic; this is just a visual indicator.
 */
export default function VoiceMeter({ active, barCount = 5, height = 32 }) {
  const [levels, setLevels] = useState(() => new Array(barCount).fill(0.15));
  const animFrameRef = useRef(null);

  useEffect(() => {
    if (!active) {
      setLevels(new Array(barCount).fill(0.15));
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
      return;
    }

    let cancelled = false;
    function tick() {
      if (cancelled) return;
      const now = Date.now();
      const newLevels = [];
      for (let i = 0; i < barCount; i++) {
        newLevels.push(0.3 + 0.5 * Math.abs(Math.sin((now / 200) + i * 1.3)));
      }
      setLevels(newLevels);
      animFrameRef.current = requestAnimationFrame(tick);
    }
    tick();

    return () => {
      cancelled = true;
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [active, barCount]);

  const barWidth = 4;
  const gap = 3;
  const totalWidth = barCount * barWidth + (barCount - 1) * gap;

  return (
    <div
      className="flex items-end justify-center"
      style={{ width: totalWidth, height, gap }}
    >
      {levels.map((level, i) => (
        <div
          key={i}
          className="rounded-full transition-all duration-75"
          style={{
            width: barWidth,
            height: `${Math.round(level * 100)}%`,
            minHeight: 4,
            background: active
              ? `linear-gradient(to top, #C9A84C, #E8C96A)`
              : 'rgba(255,255,255,0.15)',
            opacity: active ? 1 : 0.4,
          }}
        />
      ))}
    </div>
  );
}
